<script>import { getContext, onMount, onDestroy } from "svelte";
import { mapContextKey } from "./context.js";
export let tileLayer;
const { map, logger: consoleDiv } = getContext(mapContextKey);
onDestroy(() => {
  tileLayer?.remove();
});
$: {
  consoleDiv?.log(`map exists: ${!!$map}`);
  if ($map && tileLayer) {
    tileLayer.addTo($map);
  }
}
</script>